import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track5EBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track5EBlack" transform="translate(1485.000000, 555.000000)" className="track">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeLinecap="round" strokeWidth={tracksWidth}>
			<path
				d="M208.5,62.5 L207.648651,92.2972284 C207.222253,107.221156 203.276238,121.833257 196.132097,134.94305 L192.564279,141.490143 C187.725548,150.369414 181.568027,158.463402 174.301802,165.495951 L112.859339,224.962477 C111.373673,226.400365 109.843771,227.791832 108.271839,229.134872 L75.9144126,256.780668 C55.0079734,274.642878 25.2480171,277.753008 1.10019077,264.599292 L-6.11066753e-13,264 L-6.11066753e-13,264"/>

			<TrackArrow
				points="214 55 206 47 214 39"
				transform="translate(210.000000, 47.000000) rotate(-90.000000) translate(-210.000000, -47.000000) "
			/>

			<line x1="209.864346" y1="0.84163706" x2="209.864346" y2="50" strokeWidth={tracksWidth}/>
		</g>

		<Label
			coords="131.000000, 173.441508"
			onClick={(event, ref) => onLabelClick(event, ref, 'Track5EBlack')}
			text="5E"
			textCoordsX="10.7241211"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track5EBlack.propTypes = trackPropTypes;

export default Track5EBlack;


